import React from "react";
import {
  Home,
  LayoutDashboard,
  Monitor,
  Layers,
  Link as LinkIcon,
  Globe,
  Map,
  MessageSquare,
  Ticket,
  Banknote,
  Settings,
  Workflow,
  Cpu,
  Repeat,
  LifeBuoy,
  AlertCircle,
  Wrench,
  Book,
  ClipboardCheck,
  Brain,
  UserPlus,
  Database,
  GraduationCap,
  Cog,
  Building2,
  Users,
  UserCog,
  PlayCircle,
  Network,
  BookOpen,
  HelpCircle,
  UserCheck,
  GitBranch,
  Compass,
} from "lucide-react";

export const icons = {
  Home,
  Monitor,
  Layers,
  LinkIcon,
  Globe,
  LayoutDashboard,
  Map,
  MessageSquare,
  Ticket,
  Banknote,
  Settings,
  Workflow,
  Cpu,
  Repeat,
  LifeBuoy,
  AlertCircle,
  Wrench,
  Book,
  ClipboardCheck,
  Brain,
  UserPlus,
  Database,
  GraduationCap,
  Cog,
  Building2,
  Users,
  UserCog,
  PlayCircle,
  Network,
  BookOpen,
  HelpCircle,
  UserCheck,
  GitBranch,
  Compass,
};

interface IconProps {
  name: keyof typeof icons;
  isActive: boolean;
  isOpen: boolean;
  category?: boolean;
}

const Icon: React.FC<IconProps> = ({ name, isActive, isOpen, category }) => {
  const IconComponent = icons[name];
  return IconComponent ? (
    <IconComponent
      className={`${isOpen ? "mr-2" : ""} ${
        category && "!text-[#dae8fd] font-[200]"
      } text-[#dae8fd] ${
        isActive ? "!text-[#042849]" : ""
      } group-hover:!text-[#042849]`}
      size={18}
    />
  ) : null;
};

export default Icon;
